import CtaButton from '@/atoms/Buttons/CTA/CtaButton';
import FollowButton from '@/molecules/Buttons/Follow/FollowButton';
import {emitFactory} from '@/utils/events';
import {makeCamelCase} from '@/utils/helpers/string';
import {useRouter} from 'next/router';
import {navigationLinks} from './content';
import {
  StyledButtonContainer,
  StyledColorBlock,
  StyledContainer,
  StyledLink,
  StyledNavigationArtistPage,
  StyledShadow,
} from './styles';
import {NavigationArtistPageProps} from './typings';

const NavigationArtistPage = ({
  artistId,
  artistName,
  artistSlug,
  commissions = true,
  followingCount,
  hasMeAtWork,
  hasReviews,
  scrollTo,
}: NavigationArtistPageProps): JSX.Element => {
  const router = useRouter();

  return (
    <>
      <StyledColorBlock as="div" $verticalPadding="xs">
        <StyledContainer>
          <StyledNavigationArtistPage>
            {navigationLinks(artistSlug)
              .filter((link) => {
                if (link.title === 'Me at work' && !hasMeAtWork) return false;
                if (link.title === 'Reviews' && !hasReviews) return false;
                return true;
              })
              .map((link, index) => (
                <li key={index}>
                  <StyledLink
                    href={`/artist/${artistSlug}/${link.href}/`}
                    onClick={(e) => {
                      const section = scrollTo?.[makeCamelCase(link.title)];
                      if (section) {
                        e.preventDefault();

                        section.scrollIntoView({behavior: 'smooth'});
                        // Update the URL without page reload or scroll
                        router.push(`/artist/${artistSlug}/${link.href}/`, undefined, {
                          shallow: true,
                          scroll: false,
                        });
                      }
                    }}
                  >
                    {link.title}
                  </StyledLink>
                </li>
              ))}
          </StyledNavigationArtistPage>

          <StyledButtonContainer>
            <FollowButton
              artistId={artistId}
              artistSlug={artistSlug}
              artistName={artistName}
              followingCount={followingCount}
              type="text"
            />

            {commissions && (
              <CtaButton onClick={emitFactory('CLICK_COMMISSION_ARTIST')} style="tertiary">
                Commission artist
              </CtaButton>
            )}

            <CtaButton onClick={emitFactory('CLICK_CONTACT_ARTIST')} title={`Contact the artist`}>
              Contact me
            </CtaButton>
          </StyledButtonContainer>
        </StyledContainer>
      </StyledColorBlock>

      <StyledShadow />
    </>
  );
};

export default NavigationArtistPage;
